module.exports = __webpack_public_path__ + "static/divas7s-180484a7e20e52cb152cc9b98fa3ccf0.jpg";